import styled from "styled-components";

export const Container = styled.div`
  margin-top: 20px;

  h1 {
    margin-bottom: 20px;
  }

  p {
    font-size: 0.9375rem;
    color: #5e5e5e;
  }
`;
